import { useState } from "react";

const API_URL = "https://api.avexa.net/patient-history/assessments";

export const ASSESSMENT_TYPES = {
  HEALTH_ASSESSMENT: "HEALTH_ASSESSMENT",
  CARE_JOURNEY: "CARE_JOURNEY",
  CARE_NAVIGATOR: "CARE_NAVIGATOR",
  SYMPTOM_CHECKER: "SYMPTOM_CHECKER",
};

export default function useSaveAssessment() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const saveAssessment = async ({
    patientId,
    orgId,
    assessmentType,
    payload,
  }) => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Add Authorization if required
          // Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          patientId,
          orgId,
          assessmentType,
          payload,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to save assessment");
      }

      return data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    saveAssessment,
    loading,
    error,
  };
}